import {
  Injectable,
  inject,
  EnvironmentInjector,
  runInInjectionContext,
} from "@angular/core";
import { Database, ref, update as dbUpdate } from "@angular/fire/database";
import { AppStatsService } from "./app-stats.service";
import { RotateService } from "./rotate.service";
import { ApiService } from "./api.service";
import { FunctionsService } from "./functions.service";

@Injectable()
export class LocationService {
  private readonly mdb = inject(Database);
  private readonly injector = inject(EnvironmentInjector);
  private readonly fbFunc = inject(FunctionsService);

  constructor(
    private appStats: AppStatsService,
    private rotateServ: RotateService,
    private api: ApiService
  ) {}
  public updateLocationData(uid: string) {
    let geo: Promise<any> = this.api.geoLoc();
    let th: any = this;
    geo.then((resp) => {
      let locationData = resp.data;
      th.updateTVA(locationData.countryCode || locationData.country, uid);
      th.appStats.updateLocationStats(locationData);
      th.rotateServ.init(locationData.country);
    });
  }
  // Sets profile.vat and profile.currency from the user's geo. Goes through
  // the getMyPricing callable so we don't have to give the client direct read
  // access to /pricingConfig/catalog (which is server-only). The callable
  // resolves country from profile.locationData.countryCode (with a header
  // fallback that gets persisted on first hit) and returns { currency, vatRate,
  // tiers }. We just lift currency + vatRate onto the profile.
  public async updateTVA(iso2: string, uid: string) {
    console.log("[updateTVA] called with iso2:", iso2, "uid:", uid);
    if (!iso2) {
      console.warn("[updateTVA] no iso2; aborting");
      return;
    }
    try {
      const callable = this.fbFunc.httpsCallable("getMyPricing");
      const res: any = await callable({});
      const data = res && res.data;
      if (!data) {
        console.warn("[updateTVA] getMyPricing returned no data");
        return;
      }
      const update: any = {
        vat: typeof data.vatRate === "number" ? data.vatRate : 0,
        currency: (data.currency || "USD").toString().toUpperCase(),
      };
      console.log("[updateTVA] writing", { iso2: data.countryCode, ...update });
      await runInInjectionContext(this.injector, () =>
        dbUpdate(ref(this.mdb, "profiles/" + uid), update)
      );
    } catch (e) {
      console.warn("[updateTVA] failed:", e && (e as any).message);
    }
  }
}
